import styled from "styled-components";

export const Section = styled.section`
  width: 100%;
  padding: 54px 0px;
  background-color: #0f4271;
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  width: 523px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h2`
  font-size: 42px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.25px;
  text-align: center;
  color: #ffffff;
`;

export const Text = styled.p`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.24px;
  text-align: center;
  color: #ffffff;
  margin: 35px 0px;
`;